import api from "./api";
import { getSucursalInfo } from "./auth";

export async function listProfiles() {
  const sucursalId = getSucursalInfo()?.id || 1;
  return api.get(`/api/profile/${sucursalId}`);
}

export async function getProfile(id) {
  return api.get(`/api/profile/unique/${id}`);
}

export async function createProfile(payload) {
  const sucursalId = getSucursalInfo()?.id || 1;
  return api.post("/api/profile", { ...payload, sucursalId });
}

export async function updateProfile(id, payload) {
  return api.put(`/api/profile/${id}`, payload);
}

export async function deactivateProfile(id) {
  return api.delete(`/api/profile/${id}`);
}
